import t from"./text";export{StyledText}from"./text.styles";export default t;